import React from "react";
import { List, ListItem, ListItemText } from "@material-ui/core";
import { useSelector } from "react-redux";
import { RootState } from "../../reducers";
import { Torrent } from "../../types";

export default function Stat() {
  const { trackers } = useSelector(
    (state: RootState) => state.torrent.active
  ) as Torrent;
  return (
    <List component="nav">
      {trackers &&
        trackers.map(item => (
          <ListItem key={item.id}>
            <ListItemText primary={item.announce} secondary={`Tier: ${item.tier}`} />
          </ListItem>
        ))}
    </List>
  );
}
